export default ({ COLORS }) => ({
  searchInput: {
    margin: '0 0 20px'
  },
  unsplashMessage: {
    textAlign: 'right',
    color: '#555',
    fontSize: '12px',
    lineHeight: '1',
    margin: '0 0 5px',
    '& a': {
      color: COLORS.TEXT.DARK_GREY.NORMAL
    }
  }
})
